import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import { Autoplay } from 'swiper/modules';

const Supporters = () => {
  const logos = [
    {
      src: 'https://res.cloudinary.com/dzngpgki4/image/upload/v1744212807/image_1622_n4is0p.png',
      link: 'https://www.getthola.com/',

    },
    {
      src: 'https://res.cloudinary.com/dzngpgki4/image/upload/v1744212807/image_1623_w0ewam.png',
      link: 'https://4-bm.africa/',
    },
    {
      src: 'https://res.cloudinary.com/dzngpgki4/image/upload/v1744212808/image_1624_ilogag.png',
      link: 'https://foodsecurityconsortium.com/about-us/',
    },
    {
      src: 'https://res.cloudinary.com/dzngpgki4/image/upload/v1744212807/image_1526_k5t6wh.png',
      link: 'http://www.myhustle.africa',
    },
    {
      src: 'https://res.cloudinary.com/dzngpgki4/image/upload/v1744212807/image_1619_dblyxr.png',
      link: 'http://www.ahafrica.co.za',
    },
    {
      src: 'https://res.cloudinary.com/dzngpgki4/image/upload/v1744365159/1_ofoqvc.png',
      link: 'https://www.fedi.xyz/',

    },
    {
      src: 'https://res.cloudinary.com/dzngpgki4/image/upload/v1744212817/image_1642_kvzxre.png',
      link: '#', // Add actual link if available
    },
    {
      src: 'https://res.cloudinary.com/dzngpgki4/image/upload/v1744734897/WhatsApp_Image_2025-04-15_at_10.32.55_AM_bwskqg.jpg',
      link: 'https://www.getthola.com/', // Add actual link if available
    },
  ];

  return (
    <div className="md:my-1 my-3 ">
      <h1 className='text-[32px] md:flex hidden text-[#FDBD26] font-bold md:mb-5 mb-2 tracking-wide'>
      EVENT SPONSORS
      </h1>
      <h1 className='text-[16px] md:hidden flex text-[#FDBD26] font-bold md:mb-0 mb-6'>
      EVENT SPONSORS
      </h1>
      <div className='md:mt-7 mt-2'>
        <Swiper
          slidesPerView={5}
          spaceBetween={0}
          loop={true}
          autoplay={{
            delay: 2000,
            disableOnInteraction: false,
          }}
          modules={[Autoplay]}
          breakpoints={{
            320: { slidesPerView: 5.2, spaceBetween: 10 },
            640: { slidesPerView: 5.2, spaceBetween: 10 },
            1024: { slidesPerView: 5.6, spaceBetween: 20 },
          }}
        >
          {logos.map((logo, idx) => (
            <SwiperSlide key={idx} className="flex justify-center items-center mb-5">
              <a href={logo.link} target="_blank" rel="noopener noreferrer">
                <img
                  src={logo.src}
                  alt={`Logo ${idx + 1}`}
                  className="h-[25px] sm:h-[60px] md:h-[70px] lg:h-[95px] object-contain"
                />
              </a>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default Supporters;
